import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import IdealizePage from "@/pages/IdealizePage";
import Revendedor from "@/pages/Revendedor";
import Pedido from "@/pages/Pedido";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/idealize" element={<IdealizePage />} />
          <Route path="/revendedor" element={<Revendedor />} />
          <Route path="/pedido/:id" element={<Pedido />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
